import { ScanTicketService } from "./scan-qr-ticket.service";

export const SERVICES = [
  ScanTicketService,
];
